import { BUTTON_PERMISSIONS, ENABLED_BUTTON_ROLES, PAGE_PERMISSIONS, TAB_PERMISSIONS } from "../config/permissions";

export const hasTabAccess = (userRoles, componentTabs, tabName) => {
  const allowedRoles = componentTabs[tabName];
  if (!allowedRoles) {
    return true; // If tab not configured, allow access
  }

  return userRoles.some(role => allowedRoles.includes(role));
};

export const getAccessibleTabs = (userRoles, component) => {
  const componentTabs = TAB_PERMISSIONS[component];
  if (!componentTabs) {
    return []; // If not configured, return empty array
  }

  return Object.keys(componentTabs).filter(tabName =>
    hasTabAccess(userRoles, componentTabs, tabName)
  );
};

//For Sidebar
export const hasPageAccess = (userRoles, path) => {
  const allowedRoles = PAGE_PERMISSIONS[path];
  if (!allowedRoles) {
    // If path not in permissions, deny access by default (fail secure)
    return false;
  }
  return userRoles.some(role => allowedRoles.includes(role));
};

//For Feature Pages
export const allowedFeaturePages = (featureList, userRoles) => {
  return featureList.filter(feature => {
    const allowedRoles = PAGE_PERMISSIONS[feature.route];
    if (!allowedRoles) return false;
    return userRoles.some(role => allowedRoles.includes(role));
  });
}

//For Button Permission
export const hasButtonPermission = (userRoles, buttonType, component = null) => {
  let hasAccess = false;
  let disableOnly = false;

  // Check Disable-Only Rules First
  if (component && ENABLED_BUTTON_ROLES[component] && ENABLED_BUTTON_ROLES[component][buttonType]) {
    disableOnly = !userRoles.some(role =>
      ENABLED_BUTTON_ROLES[component][buttonType].includes(role)
    );
    if (!disableOnly) {
      return { hasAccess: true, disableOnly: false };
    } else {
      return { hasAccess: false, disableOnly: true };
    }
  }

  // Component Level Full Permission
  if (component && BUTTON_PERMISSIONS[component] && BUTTON_PERMISSIONS[component][buttonType]) {
    hasAccess = userRoles.some(role =>
      BUTTON_PERMISSIONS[component][buttonType].includes(role)
    );
    return { hasAccess, disableOnly: false };
  }

  // Generic Button Permission
  if (ENABLED_BUTTON_ROLES[buttonType]) {
    hasAccess = userRoles.some(role =>
      ENABLED_BUTTON_ROLES[buttonType].includes(role)
    );
    return { hasAccess, disableOnly: true };
  }

  // Generic Button Permission
  if (BUTTON_PERMISSIONS[buttonType]) {
    hasAccess = userRoles.some(role =>
      BUTTON_PERMISSIONS[buttonType].includes(role)
    );
    return { hasAccess, disableOnly: false };
  }

  // No Match → No Access
  return { hasAccess: false, disableOnly: false };
};